module.exports = __webpack_public_path__ + "static/media/History_ArrowLeft.6822234e.svg";